import { useMeteringConceptTodos } from "../../../../../hooks/useMeteringConceptTodos";
import type { WizardMissingData } from "../../../../../utils/backend-types";
import { MarkDoneActionButton } from "../../../components/MarkDoneActionButton";
import { MissingDataActionButton } from "../../../components/MissingDataActionButton";
import { AssignmentType } from "../../OnboardingWizard.constants";
import { MeteringConceptDocumentLinks } from "./MeteringConceptDocumentLinks/MeteringConceptDocumentLinks";

export interface MeteringConceptAssignmentProps {
  projectId: string;
  missingData: Array<WizardMissingData>;
  done: boolean;
  isDisabled: boolean;
  siteId: number;
  updateSiteWizard: (type: AssignmentType) => Promise<void>;
  isLoading?: boolean;
}

function MeteringConceptAssignment({
  projectId,
  missingData,
  isDisabled,
  done,
  updateSiteWizard,
  siteId,
  isLoading
}: MeteringConceptAssignmentProps) {
  const { meteringConceptTodos } = useMeteringConceptTodos(siteId, {
    enabled: done
  });

  const hasMissingData = missingData && missingData.length > 0;

  function onClickSubmit() {
    updateSiteWizard(AssignmentType.MeteringConcept);
  }

  if (done) {
    return (
      <MeteringConceptDocumentLinks
        projectId={projectId}
        todos={meteringConceptTodos}
      />
    );
  } else if (hasMissingData) {
    return (
      <MissingDataActionButton
        disabled={isDisabled}
        mt="xs"
        route="messkonzeptDaten"
      />
    );
  } else {
    return (
      <MarkDoneActionButton
        disabled={isDisabled}
        loading={isLoading}
        onClick={() => onClickSubmit()}
      />
    );
  }
}

export { MeteringConceptAssignment };
